import type { PromoConfig } from 'shared/lib/promo/common';

export type FeaturesResponse = {
  promo?: PromoConfig[];
  flags?: {
    /**
     * shows sandbox switch for individual companies
     */
    sandbox_switch_individual_company?: boolean;

    /**
     * shows coverage request button & modal
     */
    coverage_request?: boolean;

    /**
     * shows paygo refresh button
     */
    show_paygo_refresh?: boolean;
  };
};

export enum FeatureFlag {
  IMPROVED_ONE_OFF_VERIFICATION_FLOW = 'improved-one-off-verification-flow',
  ONE_OFF_FORM_REVERT_OLD_AB = 'one-off-form_revert-old-ab',
  KNOCK_NOTIFICATIONS = 'knock-notifications',
  RESETTABLE_FILTERS = 'resettable-filters',
}

export enum FeatureFlagVariant {
  CONTROL = 'control',
  ALTERNATIVE = 'alternative',
}
